import { RouteObject } from "react-router-dom";
import Home from "../pages/home/page";
import Partner from "../pages/partner/page";
import NotFound from "../pages/NotFound";

const routes: RouteObject[] = [
  {
    path: "/",
    element: <Home />,
  },
  {
    path: "/partner",
    element: <Partner />,
  },
  {
    path: "*",
    element: <NotFound />,
  },
];

export default routes;